import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getCurrentSession } from "../actions/account";
import { refreshTokensIfNeeded } from "../boot/auth";

function AuthLoader({ children, getCurrentSession }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        await refreshTokensIfNeeded();
        await getCurrentSession();
      } catch (err) {
        console.error(err);
      }

      setLoading(false);
    })();
  }, []);

  if (loading) {
    return null;
  }

  return children;
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ getCurrentSession }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthLoader);
